import React, { Component } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { api } from '../../api';

export class DeleteTranslation extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  deleteAction() {
    this.setState({ loading: true });
    const { match, obj, update, onHide } = this.props;

    api
      .delete(`/v1/books/${match.params.id}/chapters/${obj.id}`)
      .then(() => {
        update();
        onHide();
      })
      .catch(() => {
        update();
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    const { obj, onHide, disabled, ...props } = this.props;
    const { loading } = this.state;

    return (
      <Modal {...props} size="sm" aria-labelledby="delete-translation-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            Delete Translation:
            <span> "{obj.title}"</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-center">
            Do you really want to delete this translation?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => this.deleteAction()}
            disabled={disabled}
          >
            {loading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="mr-2"
              />
            )}
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
